export const HeaderImage = () => {
  return (
    <svg
      width="197"
      height="187"
      viewBox="0 0 197 187"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M83.9057 173.328L168.196 185.175C173.563 185.929 178.525 182.189 179.28 176.822L192.704 81.3034L166.324 46.4217L102.992 37.521C97.6252 36.7667 92.6629 40.5061 91.9087 45.8731L75.5537 162.245C74.7994 167.612 78.5387 172.574 83.9057 173.328Z"
        fill="white"
        stroke="#101828"
        strokeLinejoin="round"
      />
      <path
        d="M103.023 60.7612L141.046 66.105"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M99.4619 86.106L151.493 93.4184"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M96.7227 105.589L156.905 114.047"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M95.3535 115.331L161.109 124.572"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M93.9844 125.074L147.192 132.552"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M92.6162 134.814L155.823 143.698"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M98.0918 95.8501L170.514 106.028"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M89.0527 160.159L135.435 166.678"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M145.676 168.118L164.532 170.768"
        stroke="#101828"
        strokeLinecap="round"
      />
      <g filter="url(#filter0_i_7271_162180)">
        <path
          d="M166.408 46.4336L192.699 81.34L170.745 78.2545C165.974 77.584 162.65 73.1731 163.321 68.4025L166.408 46.4336Z"
          fill="#101828"
        />
      </g>
      <path
        d="M166.408 46.4336L192.699 81.34L170.745 78.2545C165.974 77.584 162.65 73.1731 163.321 68.4025L166.408 46.4336Z"
        stroke="#101828"
        strokeLinejoin="round"
      />
      <path
        d="M38.6787 154.553L121.937 136.855C127.239 135.729 130.623 130.517 129.496 125.216L109.441 30.8662L72.7218 7.11065L10.1653 20.4075C4.86396 21.5343 1.47988 26.7453 2.6067 32.0466L27.0395 146.994C28.1663 152.295 33.3774 155.679 38.6787 154.553Z"
        fill="white"
        stroke="#101828"
        strokeLinejoin="round"
      />
      <path
        d="M18.1436 42.2344L55.701 34.2513"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M23.4648 67.271L74.8589 56.3468"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M27.5557 86.5151L87.0012 73.8796"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M29.6016 96.1401L94.5524 82.3344"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M31.6465 105.76L84.2025 94.5886"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M33.6914 115.383L96.1247 102.113"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M25.5107 76.8916L97.0466 61.6862"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M39.0127 140.418L84.8268 130.68"
        stroke="#101828"
        strokeLinecap="round"
      />
      <path
        d="M94.9424 128.529L113.567 124.57"
        stroke="#101828"
        strokeLinecap="round"
      />
      <g filter="url(#filter1_i_7271_162180)">
        <path
          d="M72.8057 7.09277L109.45 30.9021L87.7641 35.5115C83.0518 36.5131 78.4198 33.505 77.4181 28.7928L72.8057 7.09277Z"
          fill="#101828"
        />
      </g>
      <path
        d="M72.8057 7.09277L109.45 30.9021L87.7641 35.5115C83.0518 36.5131 78.4198 33.505 77.4181 28.7928L72.8057 7.09277Z"
        stroke="#101828"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_i_7271_162180"
          x="162.734"
          y="45.9336"
          width="30.4648"
          height="35.9062"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.72592" dy="-0.545183" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_7271_162180"
          />
        </filter>
        <filter
          id="filter1_i_7271_162180"
          x="72.3057"
          y="6.59277"
          width="37.6436"
          height="29.6113"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.72592" dy="-0.545183" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_7271_162180"
          />
        </filter>
      </defs>
    </svg>
  );
};
